import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { getPartnerReviews } from "../services/partnerAuthService";

const getErr = (err, fallback) => err.response?.data?.error || fallback;
const Stars = ({ rating }) => "★".repeat(rating) + "☆".repeat(5 - rating);

export default function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let profile = null;
    try {
      profile = JSON.parse(localStorage.getItem("partner_profile"));
    } catch {
      profile = null;
    }
    if (!profile?._id) {
      setError("Could not identify your account. Please log in again.");
      setLoading(false);
      return;
    }
    getPartnerReviews(profile._id)
      .then(({ data }) => setReviews(data.data || []))
      .catch((err) => setError(getErr(err, "Failed to load reviews")))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p>Loading reviews…</p>;

  const avg = reviews.length ? (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1) : 0;

  return (
    <div>
      <h4 className="mb-3">Reviews &amp; Ratings</h4>
      {error && <Alert variant="danger">{error}</Alert>}

      <div className="partner-card mb-4 d-flex align-items-center gap-3">
        <div className="partner-stat-value">{avg}</div>
        <div>
          <div className="text-warning" style={{ fontSize: 18 }}><Stars rating={Math.round(avg)} /></div>
          <div className="partner-stat-label">{reviews.length} review{reviews.length === 1 ? "" : "s"}</div>
        </div>
      </div>

      {reviews.length === 0 ? (
        <div className="partner-card partner-empty">No reviews yet. Reviews appear here once customers complete a booking with you.</div>
      ) : (
        <div className="d-flex flex-column gap-3">
          {reviews.map((r) => (
            <div key={r._id} className="partner-card">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <span className="text-warning"><Stars rating={r.rating} /></span>
                <small className="text-muted">{new Date(r.createdAt).toLocaleDateString()}</small>
              </div>
              {r.text && <p className="mb-1">{r.text}</p>}
              <small className="text-muted">{r.userId?.name || "Customer"}</small>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
